export default {
  moneyToString: (n: Number | String) => {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
};
